export const SET_PRESTASHOP_PRODUCTS= 'SET_PRESTASHOP_PRODUCTS';
